var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "rootVM" } }, [
    _vm._m(0),
    _c("div", { staticClass: "panel panel-flat" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.search.apply(null, arguments)
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.search.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-5" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("select2", {
                      attrs: { options: _vm.options.dangerDtmOption },
                      model: {
                        value: _vm.searchVM.dangerDtm,
                        callback: function($$v) {
                          _vm.$set(_vm.searchVM, "dangerDtm", $$v)
                        },
                        expression: "searchVM.dangerDtm"
                      }
                    }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchVM.dangerOccurDtmStat,
                          expression: "searchVM.dangerOccurDtmStat"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "min-width": "210px" },
                      attrs: { type: "datetime-local", step: "1" },
                      domProps: { value: _vm.searchVM.dangerOccurDtmStat },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.searchVM,
                            "dangerOccurDtmStat",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v("  ~  "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchVM.dangerOccurDtmEnd,
                          expression: "searchVM.dangerOccurDtmEnd"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "min-width": "210px" },
                      attrs: {
                        type: "datetime-local",
                        step: "1",
                        min: _vm.searchVM.dangerOccurDtmStat,
                        max: _vm.maxDay
                      },
                      domProps: { value: _vm.searchVM.dangerOccurDtmEnd },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.searchVM,
                            "dangerOccurDtmEnd",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "col-md-2", staticStyle: { width: "250px" } },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticStyle: { width: "90px" } }, [
                      _vm._v(_vm._s(_vm.detailsFieldMap.searchSite))
                    ]),
                    _c(
                      "div",
                      { staticClass: "select-wrapper" },
                      [
                        _c(
                          "select2",
                          {
                            attrs: { disabled: _vm.isDisabledSearchSite },
                            model: {
                              value: _vm.searchVM.siteId,
                              callback: function($$v) {
                                _vm.$set(_vm.searchVM, "siteId", $$v)
                              },
                              expression: "searchVM.siteId"
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("전체")
                            ]),
                            _vm._l(_vm.options.siteOptions, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.siteId,
                                  domProps: { value: item.siteId }
                                },
                                [_vm._v(" " + _vm._s(item.siteNm) + " ")]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "col-md-2",
                  staticStyle: { width: "250px", "margin-left": "10px" }
                },
                [
                  _vm.cctvChoiceMethod == "cctvSelect"
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticStyle: { width: "73px" } }, [
                          _vm._v(_vm._s(_vm.detailsFieldMap.searchCctv))
                        ]),
                        _c(
                          "div",
                          { staticClass: "select-wrapper" },
                          [
                            _c(
                              "select2",
                              {
                                model: {
                                  value:
                                    _vm.searchVM.cctvInstallPlaceContSelect,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchVM,
                                      "cctvInstallPlaceContSelect",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "searchVM.cctvInstallPlaceContSelect"
                                }
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("전체")
                                ]),
                                _vm._l(_vm.options.cctvOptions, function(item) {
                                  return _c(
                                    "option",
                                    {
                                      key: item.cctvInstallPlaceCont,
                                      domProps: {
                                        value: item.cctvInstallPlaceCont
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.cctvInstallPlaceCont) +
                                          " "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.cctvChoiceMethod == "cctvText"
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticStyle: { width: "73px" } }, [
                          _vm._v(_vm._s(_vm.detailsFieldMap.searchCctv))
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchVM.cctvInstallPlaceContText,
                              expression: "searchVM.cctvInstallPlaceContText"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: _vm.detailsFieldMap.searchCctv
                          },
                          domProps: {
                            value: _vm.searchVM.cctvInstallPlaceContText
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.searchVM,
                                "cctvInstallPlaceContText",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "col-md-1",
                  staticStyle: {
                    width: "300px",
                    "margin-left": "-30px",
                    display: "flex"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      staticStyle: { width: "80px" }
                    },
                    [
                      _c("label", { staticStyle: { "margin-top": "8px" } }, [
                        _vm._v("이력")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "checkbox",
                          staticStyle: { "margin-bottom": "25px" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchVM.isCheckedCctvAll,
                                expression: "searchVM.isCheckedCctvAll"
                              }
                            ],
                            attrs: { type: "checkbox", id: "check" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.searchVM.isCheckedCctvAll
                              )
                                ? _vm._i(_vm.searchVM.isCheckedCctvAll, null) >
                                  -1
                                : _vm.searchVM.isCheckedCctvAll
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.searchVM.isCheckedCctvAll,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.searchVM,
                                        "isCheckedCctvAll",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.searchVM,
                                        "isCheckedCctvAll",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.searchVM,
                                    "isCheckedCctvAll",
                                    $$c
                                  )
                                }
                              }
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _c("div", { staticStyle: { "margin-left": "20px" } }, [
                    _c("span", [
                      _vm._v(" (CCTV 검색어 입력 방법) "),
                      _c("div", { staticStyle: { "margin-left": "25px" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cctvChoiceMethod,
                              expression: "cctvChoiceMethod"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "cctvSelect",
                            value: "cctvSelect",
                            checked: ""
                          },
                          domProps: {
                            checked: _vm._q(_vm.cctvChoiceMethod, "cctvSelect")
                          },
                          on: {
                            change: function($event) {
                              _vm.cctvChoiceMethod = "cctvSelect"
                            }
                          }
                        }),
                        _c("label", { attrs: { for: "cctvSelect" } }, [
                          _vm._v("선택")
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cctvChoiceMethod,
                              expression: "cctvChoiceMethod"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "cctvText",
                            value: "cctvText"
                          },
                          domProps: {
                            checked: _vm._q(_vm.cctvChoiceMethod, "cctvText")
                          },
                          on: {
                            change: function($event) {
                              _vm.cctvChoiceMethod = "cctvText"
                            }
                          }
                        }),
                        _c("label", { attrs: { for: "cctvText" } }, [
                          _vm._v("텍스트")
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-md-2",
                  staticStyle: { width: "250px", "margin-left": "30px" }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.detailsFieldMap.searchVideoDangerActnDvsnCd)
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "select-wrapper" },
                      [
                        _c(
                          "select2",
                          {
                            model: {
                              value: _vm.searchVM.videoDangerActnDvsnCd,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.searchVM,
                                  "videoDangerActnDvsnCd",
                                  $$v
                                )
                              },
                              expression: "searchVM.videoDangerActnDvsnCd"
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("전체")
                            ]),
                            _vm._l(
                              _vm.options.videoDangerActnDvsnCdOption,
                              function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: item.value,
                                    domProps: { value: item.value }
                                  },
                                  [_vm._v(" " + _vm._s(item.text) + " ")]
                                )
                              }
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "col-md-3", staticStyle: { width: "300px" } },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.detailsFieldMap.searchObject))
                    ]),
                    _c(
                      "div",
                      { staticClass: "select-wrapper" },
                      [
                        _c(
                          "select2",
                          {
                            model: {
                              value: _vm.searchVM.objectId,
                              callback: function($$v) {
                                _vm.$set(_vm.searchVM, "objectId", $$v)
                              },
                              expression: "searchVM.objectId"
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("전체")
                            ]),
                            _vm._l(_vm.options.objectOptions, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.objectId,
                                  domProps: { value: item.objectId }
                                },
                                [_vm._v(" " + _vm._s(item.objectNm) + " ")]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "col-md-3", staticStyle: { width: "300px" } },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.detailsFieldMap.searchTarget))
                    ]),
                    _c(
                      "div",
                      { staticClass: "select-wrapper" },
                      [
                        _c(
                          "select2",
                          {
                            attrs: { disabled: _vm.searchVM.objectId == "" },
                            model: {
                              value: _vm.searchVM.targetId,
                              callback: function($$v) {
                                _vm.$set(_vm.searchVM, "targetId", $$v)
                              },
                              expression: "searchVM.targetId"
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("전체")
                            ]),
                            _vm._l(_vm.options.targetOptions, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.targetId,
                                  domProps: { value: item.targetId }
                                },
                                [_vm._v(" " + _vm._s(item.targetNm) + " ")]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._m(1)
            ])
          ]
        )
      ])
    ]),
    _c(
      "div",
      [
        _c("KendoGrid", {
          ref: "grid",
          attrs: {
            "auto-bind": false,
            "api-url": _vm.apiUrl.pageListApi,
            columns: _vm.gridColumns,
            "apply-search-condition": _vm.applySearchStateOnGridLoad
          },
          on: { "selected-row-item-changed": _vm.selectedRowItemChanged }
        })
      ],
      1
    ),
    _c("div", { staticClass: "mt-10 mb-15 text-right" }),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isEditMode,
            expression: "isEditMode"
          }
        ],
        staticClass: "form-horizontal form-validate-jquery",
        attrs: { id: "detailFrames" }
      },
      [
        _c("div", { staticClass: "panel panel-flat" }, [
          _c("div", { staticClass: "panel-heading" }, [
            _c("h6", { staticClass: "panel-title" }, [
              _c("b", [
                _vm._v(
                  "프레임 정보 (" +
                    _vm._s(this.detailsItem.cctvInstallPlaceCont) +
                    ")"
                )
              ])
            ]),
            _c("div", { staticClass: "heading-elements" }, [
              _c("ul", { staticClass: "icons-list" }, [
                _c("li", [
                  _c("a", {
                    attrs: { "data-action": "collapse" },
                    on: { click: _vm.pannelHidden }
                  })
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              {
                staticClass: "border",
                staticStyle: {
                  width: "57vw",
                  height: "60vh",
                  "overflow-y": "auto"
                }
              },
              [
                _vm.isSelected == true
                  ? _c("video-box", {
                      key: _vm.keyForRerendering,
                      attrs: {
                        detailsItem: _vm.detailsItem,
                        urlFlag: "danger",
                        imgWrapper: _vm.detailsItem.inqDangerOccurFrameImgOutVOs
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "border",
                staticStyle: { width: "14vw", margin: "0 0 20px 20px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "rhtBox", staticStyle: { height: "auto" } },
                  [
                    _vm._m(2),
                    _vm._l(_vm.dangerOccurObjectsAndTargets, function(
                      targets,
                      object
                    ) {
                      return _c(
                        "div",
                        {
                          key: object,
                          staticClass: "row",
                          staticStyle: {
                            width: "100%",
                            "min-height": "135px",
                            margin: "0px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "17px",
                                "margin-bottom": "10px",
                                "padding-left": "15px",
                                "margin-top": "15px",
                                "margin-left": "20px"
                              }
                            },
                            [_vm._v(_vm._s(object))]
                          ),
                          _vm._l(targets, function(target) {
                            return _c(
                              "li",
                              {
                                key: target,
                                staticStyle: { "margin-left": "20px" }
                              },
                              [_vm._v(" " + _vm._s(target) + " ")]
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "rhtBox" },
                  [
                    _vm._m(3),
                    _vm._l(_vm.detailsItem.inqDangerOccurActnOutVOs, function(
                      item,
                      index
                    ) {
                      return _c("div", { key: index }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "15px",
                              "margin-bottom": "15px",
                              "margin-left": "20px",
                              "padding-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.actnDtm) +
                                " : " +
                                _vm._s(item.videoDangerActnDvsnCdNm) +
                                " "
                            )
                          ]
                        )
                      ])
                    })
                  ],
                  2
                ),
                _c("div", {
                  staticClass: "border-bottom",
                  staticStyle: { "margin-bottom": "20px" }
                }),
                _vm.curDangerDvsnCd != "04"
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          height: "auto",
                          display: "flex",
                          padding: "10px"
                        }
                      },
                      [
                        _vm._m(4),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.detailsItem.takingActionMin,
                              expression: "detailsItem.takingActionMin"
                            }
                          ],
                          staticClass: "form-control",
                          staticStyle: {
                            display: "inline",
                            width: "50px",
                            "text-align": "center"
                          },
                          attrs: { type: "number" },
                          domProps: { value: _vm.detailsItem.takingActionMin },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.detailsItem,
                                "takingActionMin",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._m(5),
                        _c(
                          "button",
                          {
                            staticClass: "btn bg-primary",
                            staticStyle: { "margin-left": "10px" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.takingAction.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("조치중")]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticStyle: { display: "flex", margin: "10px 0px" } },
                  [
                    _vm.detailsItem.videoDangerActnDvsnCd != "04"
                      ? _c("div", [
                          _vm.detailsItem.videoDangerActnDvsnCd != "05"
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn bg-primary",
                                  staticStyle: { flex: "1", margin: "0px 5px" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.misdetection.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" 오인식 ")]
                              )
                            : _vm._e(),
                          _vm.detailsItem.videoDangerActnDvsnCd == "05"
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn bg-primary",
                                  staticStyle: { flex: "1", margin: "0px 5px" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deMisdetection.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" 오인식 취소 ")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm.menuGubun != "01"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn bg-primary",
                            staticStyle: { flex: "1", margin: "0px 5px" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.popupExemplaryCase.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v(" 모범사례 ")]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        ])
      ]
    ),
    _c("div", { ref: "popupExemplaryCase", staticClass: "modal" }, [
      _c("div", { staticClass: "modal-content" }, [
        _c(
          "div",
          {
            staticClass: "form-horizontal form-validate-jquery popupEx",
            attrs: { action: "#" }
          },
          [
            _c("div", [
              _c("div", { staticClass: "panel-heading" }, [
                _c("input", {
                  attrs: { type: "button", id: "ex-caseBtn", value: "사진" }
                }),
                _c("input", {
                  attrs: { type: "button", id: "lawBtn", value: "관련법령" }
                }),
                _c(
                  "span",
                  {
                    staticClass: "close",
                    on: { click: _vm.popupExemplaryCaseClose }
                  },
                  [_vm._v("×")]
                )
              ]),
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "panel panel-flat exCase row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-9", attrs: { align: "center" } },
                    [
                      _c("img", {
                        staticStyle: {
                          "max-width": "100%",
                          height: "600px",
                          "object-fit": "contain"
                        },
                        attrs: { src: _vm.imageSrc }
                      })
                    ]
                  ),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c(
                      "div",
                      {
                        ref: "tableWrapperImage",
                        staticClass: "table-wrapper"
                      },
                      [
                        _c("table", { staticClass: "table" }, [
                          _vm._m(6),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.detailsItem.images, function(
                                row,
                                index
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: index,
                                    class: {
                                      active:
                                        _vm.activeImageForExemplaryCase == index
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickRowImage(index)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(_vm._s(row.regDtm.slice(0, 10)))
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(_vm._s(row.imgOriNm))
                                    ])
                                  ]
                                )
                              }),
                              _vm._m(7)
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "panel panel-flat law-panel",
                    attrs: { id: "law-panel" }
                  },
                  [
                    _c("div", { staticClass: "panel-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "row",
                          staticStyle: { "padding-left": "10px" }
                        },
                        [
                          _c("div", { staticClass: "col-md-9" }, [
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticStyle: {
                                    width: "70px",
                                    "font-size": "18px"
                                  }
                                },
                                [_vm._v("법조항")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.detailsItem.lawClss,
                                    expression: "detailsItem.lawClss"
                                  }
                                ],
                                staticClass: "form-control",
                                staticStyle: { "margin-bottom": "15px" },
                                attrs: { type: "text", disabled: true },
                                domProps: { value: _vm.detailsItem.lawClss },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.detailsItem,
                                      "lawClss",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _c(
                              "label",
                              { staticStyle: { "font-size": "18px" } },
                              [_vm._v("법령")]
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.detailsItem.stte,
                                  expression: "detailsItem.stte"
                                }
                              ],
                              staticClass: "form-control",
                              staticStyle: { "margin-bottom": "15px" },
                              attrs: { disabled: "true" },
                              domProps: { value: _vm.detailsItem.stte },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.detailsItem,
                                    "stte",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c(
                              "div",
                              {
                                ref: "tableWrapperLaw",
                                staticClass: "table-wrapper"
                              },
                              [
                                _c("table", { staticClass: "table" }, [
                                  _vm._m(8),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(_vm.detailsItem.laws, function(
                                        row,
                                        index
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            key: index,
                                            class: {
                                              active: _vm.activeLaw == index
                                            },
                                            attrs: { id: "laws_" + index },
                                            on: {
                                              click: function($event) {
                                                return _vm.clickRowLaw(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(row.regDtm.slice(0, 10))
                                              )
                                            ]),
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  colspan: "2",
                                                  align: "left"
                                                }
                                              },
                                              [_vm._v(_vm._s(row.lawClss))]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._m(9)
                                    ],
                                    2
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ]),
    _c("div", { ref: "showPlayVideo", staticClass: "modal" }, [
      _c("div", { staticClass: "modal-content" }, [
        _c(
          "span",
          { staticClass: "close", on: { click: _vm.showPlayVideoClose } },
          [_vm._v("×")]
        ),
        _c("div", { staticStyle: { height: "30px" } }),
        _c(
          "div",
          {
            staticClass: "row",
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "justify-content": "center"
            }
          },
          [
            _c("video", {
              attrs: {
                width: "100%",
                autoplay: "",
                controls: "",
                src: this.playVideoUrl
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "pageTitle" } }, [
      _c("b", [_vm._v("위험발생이력 - 비디오")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mb-10 text-right", staticStyle: { float: "right" } },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-labeled bg-primary",
            attrs: { type: "submit" }
          },
          [
            _c("b", [_c("i", { staticClass: "icon-search4" })]),
            _vm._v(" 조회 ")
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "inline-block", width: "100%" } },
      [_c("h3", [_vm._v("조치 대상")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h3", [_vm._v("조치 이력")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          background: "none",
          "flex-grow": "2",
          margin: "auto",
          "text-align": "center"
        }
      },
      [
        _c("label", { staticStyle: { margin: "0px auto" } }, [
          _vm._v("조치요청을 하시겠습니까?")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          background: "none",
          margin: "auto",
          "text-align": "center",
          "margin-left": "5px"
        }
      },
      [_c("label", { staticStyle: { margin: "0px auto" } }, [_vm._v("분")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", [_vm._v("일자")]), _c("th", [_vm._v("파일명")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { attrs: { empty: "" } }, [
      _c("td", { attrs: { colspan: "3" } }, [
        _vm._v("추가된 이미지가 없습니다")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { attrs: { algin: "center" } }, [
        _c("th", [_vm._v("일자")]),
        _c("th", [_vm._v("법조항")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { attrs: { empty: "" } }, [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("추가된 법령이 없습니다")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }